<div class="demurrage-container" [ngClass]="{ 'dark-theme': isDarkMode() }">
  <p class="title">
    Demurrage
    <mat-icon class="titleIcon">chevron_right</mat-icon>Manual Demurrage Calculation
  </p>

  <form [formGroup]="demurrageForm" class="demurrage-form">
    <mat-horizontal-stepper linear>
      
      <!-- STEP 1 -->
      <mat-step [stepControl]="voyageForm" label="Voyage">
        <div formGroupName="voyage" class="step-container">
          <div class="section-header">Voyage Details</div>

          <!-- Skeleton Loading View -->
          <div *ngIf="isLoading" class="form-grid">
            <div class="form-group" *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12]">
              <div class="skeleton skeleton-label"></div>
              <div class="skeleton skeleton-input"></div>
            </div>
          </div>

          <!-- Real Form Content -->
          <div *ngIf="!isLoading" class="form-grid">
            <div class="form-group">
              <label>Vessel *</label>
              <input type="text" formControlName="vessel" [matAutocomplete]="vesselAuto" placeholder="Enter Here" />
              <mat-autocomplete #vesselAuto="matAutocomplete" (optionSelected)="onVesselSelected($event)">
                <mat-option *ngFor="let vessel of filteredVessels | async" [value]="vessel">
                  {{ vessel.vesselName }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="form-group">
              <label>IMO</label>
              <input formControlName="vessel_imo" placeholder="Enter Here" />
            </div>
            <div class="form-group">
              <label>Voyage Number *</label>
              <input formControlName="voyage_no" placeholder="Enter Here" />
            </div>
            <div class="form-group">
              <label>Charterparty Terms *</label>
              <input type="text" formControlName="charterparty_terms" placeholder="Enter or Select" [matAutocomplete]="charterpartyAuto" />
              <mat-autocomplete #charterpartyAuto="matAutocomplete">
                <mat-option *ngFor="let option of filteredCharterpartyOptions | async" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="form-group">
              <label>Client Name</label>
              <select formControlName="client_name">
                <option value="">Select Client</option>
                <option *ngFor="let client of clientOptions" [value]="client.client_name">
                  {{ client.client_name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Charteres name</label>
              <input formControlName="charteres_name" placeholder="Enter Here" />
            </div>
            <div class="form-group">
              <label>Allowed Laytime (Hours)</label>
              <input type="number" formControlName="allowed_laytime_hours" />
            </div>
            <div class="form-group">
              <label>Demurrage Rate (USD/Day)</label>
              <input type="number" formControlName="demurrage_rate_usd_per_day" />
            </div>
            <div class="form-group">
              <label>Address Commission %</label>
              <input type="number" formControlName="address_commission_percent" />
            </div>
            <div class="form-group">
              <label>Freight</label>
              <input formControlName="freight" />
            </div>
            <div class="form-group">
              <label>BL Dated</label>
              <input type="date" formControlName="bl_dated" />
            </div>
            <div class="form-group">
              <label>CP Dated</label>
              <input type="date" formControlName="cp_dated" />
            </div>
            <div class="form-group">
              <label>Laycan</label>
              <input formControlName="laycan" />
            </div>
            <div class="form-group">
              <label>Laycan Narrowed ?</label>
              <input type="date" formControlName="laycan_narrowed_date" />
              <div class="time-range">
                <input type="time" formControlName="laycan_narrowed_start_time" />
                <label>to</label>
                <input type="time" formControlName="laycan_narrowed_end_time" />
              </div>
            </div>
            <div class="form-group">
              <label>Actual Rotation</label>
              <input formControlName="actual_rotation" />
            </div>
            <div class="form-group">
              <label>CP Speed</label>
              <input formControlName="cp_speed" />
            </div>
            <div class="form-group">
              <label>Timebar Clause</label>
              <input formControlName="timebar_clause" />
            </div>
            <div class="form-group">
              <label>Undisputed Demurrage Paid</label>
              <input type="number" formControlName="undisputed_demurrage_paid" />
            </div>
            <div class="form-group">
              <label>Additional Laytime</label>
              <input formControlName="additional_laytime" />
            </div>
          </div>

          <div class="text-right">
            <button class="btn btn-light hover-button apply" color="primary" matStepperNext [disabled]="isLoading">
              Next <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </mat-step>

      <!-- STEP 2: Loading -->
      <mat-step label="Loading">
        <div class="step-container">
          <div class="section-header">Loading Ports</div>

          <!-- Skeleton Loading View -->
          <div *ngIf="isLoading" class="form-grid">
            <div class="form-group" *ngFor="let item of [1,2,3,4,5,6]">
              <div class="skeleton skeleton-label"></div>
              <div class="skeleton skeleton-input"></div>
            </div>
          </div>

          <!-- Real Form Content -->
          <div *ngIf="!isLoading" formArrayName="load_ports">
            <div *ngFor="let port of loadPorts.controls; let pIndex = index" [formGroupName]="pIndex" style="margin-bottom: 20px; padding: 15px; border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 8px;">
              <!-- Existing load ports markup -->
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                <div class="section-header" style="margin: 0; font-size: 1.1em; border-bottom: none;">Load Port {{ pIndex + 1 }}</div>
                <button *ngIf="loadPorts.length > 1" type="button" class="btn btn-light hover-button" style="border: 1px solid #dc3545; color: #dc3545;" (click)="removeLoadPort(pIndex)">Remove Port</button>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label>Port</label>
                  <input formControlName="port" />
                </div>
                <div class="form-group">
                  <label>Terminal</label>
                  <input formControlName="terminal" />
                </div>
                <div class="form-group">
                  <label>Start Time</label>
                  <input type="datetime-local" formControlName="start_time" />
                </div>
                <div class="form-group">
                  <label>Start Event</label>
                  <input formControlName="start_event" />
                </div>
                <div class="form-group">
                  <label>End Time</label>
                  <input type="datetime-local" formControlName="end_time" />
                </div>
                <div class="form-group">
                  <label>End Event</label>
                  <input formControlName="end_event" />
                </div>
                <div class="form-group">
                  <label>Hours</label>
                  <input type="text" readonly [value]="calculateHours(port.get('start_time')?.value, port.get('end_time')?.value)" />
                </div>
                <div class="form-group full-width">
                  <label>Comments / Clause</label>
                  <textarea formControlName="comments_clause"></textarea>
                </div>
              </div>

              <!-- Deductions -->
              <div style="margin-top: 20px; background: rgba(0, 0, 0, 0.2); padding: 10px; border-radius: 8px;">
                <div class="section-header" style="font-size: 1em; padding-bottom: 5px;">Deductions</div>
                <div formArrayName="deductions">
                  <div class="deduction-card" *ngFor="let item of getLoadDeductions(pIndex).controls; let dIndex = index" [formGroupName]="dIndex" style="position: relative;">
                    <mat-icon style="position: absolute; top: 10px; right: 10px; cursor: pointer; color: #dc3545; z-index: 10;" (click)="removeLoadDeduction(pIndex, dIndex)">close</mat-icon>
                    <div class="form-grid">
                      <div class="form-group">
                        <label>Event Name</label>
                        <select formControlName="event_name" (change)="onEventNameChange($event, 'load', pIndex, dIndex)">
                          <option value="">Select Event</option>
                          <option *ngFor="let event of eventOptions" [value]="event">{{ event }}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Start Time</label>
                        <input type="datetime-local" formControlName="start_time" />
                      </div>
                      <div class="form-group">
                        <label>End Time</label>
                        <input type="datetime-local" formControlName="end_time" />
                      </div>
                      <div class="form-group">
                        <label>Hours</label>
                        <input type="text" readonly [value]="calculateHours(item.get('start_time')?.value, item.get('end_time')?.value, item.get('to_count')?.value)" />
                      </div>
                      <div class="form-group">
                        <label>To Count</label>
                        <input type="number" formControlName="to_count" />
                      </div>
                      <div class="form-group full-width">
                        <label>Comments / Clause</label>
                        <textarea formControlName="comments_clause"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="button" class="btn btn-light hover-button apply" (click)="addLoadDeduction(pIndex)">
                    + Add Deduction
                  </button>
                </div>
              </div>

              <!-- Summary -->
              <div class="summary-box" style="margin-top: 15px;">
                <div class="summary-row">
                  <span style="font-weight: bold; color: #fff">Gross Laytime Used</span>
                  <strong style="color: white">{{ getGrossLaytimeUsed('load', pIndex) }} hrs</strong>
                </div>
                <div class="summary-row">
                  <span style="font-weight: bold; color: #fff">Total Deductions</span>
                  <strong class="text-danger">- {{ getTotalDeductions('load', pIndex) }} hrs</strong>
                </div>
                <div class="summary-row total">
                  <span style="font-weight: bold; color: #fff">Net Laytime Used</span>
                  <strong class="text-primary">{{ getNetLaytimeUsed('load', pIndex) }} hrs</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="text-right" style="margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 15px;">
            <button type="button" class="btn btn-light hover-button apply" (click)="addLoadPort()" style="margin-right: auto; float: left; white-space: nowrap; width: max-content; padding: 8px 16px;">
              + Add Load Port
            </button>
            <button class="btn btn-light hover-button apply" matStepperPrevious>
              <mat-icon>arrow_back</mat-icon>Back
            </button>
            <button class="btn btn-light hover-button apply" color="primary" matStepperNext>
              Next <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </mat-step>

      <!-- STEP 3: Discharge -->
      <mat-step label="Discharge">
        <div class="step-container">
          <div class="section-header">Discharge Ports</div>

          <!-- Skeleton Loading View -->
          <div *ngIf="isLoading" class="form-grid">
            <div class="form-group" *ngFor="let item of [1,2,3,4,5,6]">
              <div class="skeleton skeleton-label"></div>
              <div class="skeleton skeleton-input"></div>
            </div>
          </div>

          <!-- Real Form Content -->
          <div *ngIf="!isLoading" formArrayName="discharge_ports">
            <div *ngFor="let port of dischargePorts.controls; let pIndex = index" [formGroupName]="pIndex" style="margin-bottom: 20px; padding: 15px; border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 8px;">
              <!-- Existing discharge ports markup -->
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                <div class="section-header" style="margin: 0; font-size: 1.1em; border-bottom: none;">Discharge Port {{ pIndex + 1 }}</div>
                <button *ngIf="dischargePorts.length > 1" type="button" class="btn btn-light hover-button" style="border: 1px solid #dc3545; color: #dc3545;" (click)="removeDischargePort(pIndex)">Remove Port</button>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label>Port</label>
                  <input formControlName="port" />
                </div>
                <div class="form-group">
                  <label>Terminal</label>
                  <input formControlName="terminal" />
                </div>
                <div class="form-group">
                  <label>Start Time</label>
                  <input type="datetime-local" formControlName="start_time" />
                </div>
                <div class="form-group">
                  <label>Start Event</label>
                  <input formControlName="start_event" />
                </div>
                <div class="form-group">
                  <label>End Time</label>
                  <input type="datetime-local" formControlName="end_time" />
                </div>
                <div class="form-group">
                  <label>End Event</label>
                  <input formControlName="end_event" />
                </div>
                <div class="form-group">
                  <label>Hours</label>
                  <input type="text" readonly [value]="calculateHours(port.get('start_time')?.value, port.get('end_time')?.value)" />
                </div>
                <div class="form-group full-width">
                  <label>Comments / Clause</label>
                  <textarea formControlName="comments_clause"></textarea>
                </div>
              </div>

              <!-- Deductions -->
              <div style="margin-top: 20px; background: rgba(0, 0, 0, 0.2); padding: 10px; border-radius: 8px;">
                <div class="section-header" style="font-size: 1em; padding-bottom: 5px;">Deductions</div>
                <div formArrayName="deductions">
                  <div class="deduction-card" *ngFor="let item of getDischargeDeductions(pIndex).controls; let dIndex = index" [formGroupName]="dIndex" style="position: relative;">
                    <mat-icon style="position: absolute; top: 10px; right: 10px; cursor: pointer; color: #dc3545; z-index: 10;" (click)="removeDischargeDeduction(pIndex, dIndex)">close</mat-icon>
                    <div class="form-grid">
                      <div class="form-group">
                        <label>Event Name</label>
                        <select formControlName="event_name" (change)="onEventNameChange($event, 'discharge', pIndex, dIndex)">
                          <option value="">Select Event</option>
                          <option *ngFor="let event of eventOptions" [value]="event">{{ event }}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Start Time</label>
                        <input type="datetime-local" formControlName="start_time" />
                      </div>
                      <div class="form-group">
                        <label>End Time</label>
                        <input type="datetime-local" formControlName="end_time" />
                      </div>
                      <div class="form-group">
                        <label>Hours</label>
                        <input type="text" readonly [value]="calculateHours(item.get('start_time')?.value, item.get('end_time')?.value, item.get('to_count')?.value)" />
                      </div>
                      <div class="form-group">
                        <label>To Count</label>
                        <input type="number" formControlName="to_count" />
                      </div>
                      <div class="form-group full-width">
                        <label>Comments / Clause</label>
                        <textarea formControlName="comments_clause"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button type="button" class="btn btn-light hover-button apply" (click)="addDischargeDeduction(pIndex)">
                    + Add Deduction
                  </button>
                </div>
              </div>

              <!-- Summary -->
              <div class="summary-box" style="margin-top: 15px;">
                <div class="summary-row">
                  <span style="font-weight: bold; color: #fff">Gross Laytime Used</span>
                  <strong style="color: white">{{ getGrossLaytimeUsed('discharge', pIndex) }} hrs</strong>
                </div>
                <div class="summary-row">
                  <span style="font-weight: bold; color: #fff">Total Deductions</span>
                  <strong class="text-danger">- {{ getTotalDeductions('discharge', pIndex) }} hrs</strong>
                </div>
                <div class="summary-row total">
                  <span style="font-weight: bold; color: #fff">Net Laytime Used</span>
                  <strong class="text-primary">{{ getNetLaytimeUsed('discharge', pIndex) }} hrs</strong>
                </div>
              </div>
            </div>
          </div>

          <!-- In Step 3: Discharge section before or beside the Final PDF checkbox -->
          <div class="text-right" style="display: flex; align-items: center; justify-content: flex-end; gap: 15px; margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 15px;">
            <button type="button" class="btn btn-light hover-button apply" (click)="addDischargePort()" style="margin-right: auto; white-space: nowrap; width: max-content; padding: 8px 16px;">
              + Add Discharge Port
            </button>

            <!-- NEW REPORT SCOPE SELECTOR -->
            <div style="display: flex; align-items: center; gap: 8px;">
              <label style="color: white; margin-bottom: 0; font-size: 14px; font-weight: 500;">Report Scope:</label>
              <select formControlName="report_scope" style="height: 36px; padding: 0 10px; border-radius: 6px; background: #1e2d46; color: white; border: 1px solid #42526e;">
                <option value="BOTH">Both Ports</option>
                <option value="LOAD_ONLY">Load Port Only</option>
                <option value="DISCHARGE_ONLY">Discharge Port Only</option>
              </select>
            </div>

            <label style="color: white; margin-right: 5px; display: inline-flex; align-items: center; cursor: pointer; font-size: 14px; margin-bottom: 0;">
              <input type="checkbox" formControlName="final_pdf" style="margin-right: 8px; width: 16px; height: 16px; cursor: pointer;" />
              Final PDF
            </label>

            <button class="btn btn-light hover-button apply" matStepperPrevious>
              <mat-icon>arrow_back</mat-icon>Back
            </button>
            <button type="button" class="btn btn-light hover-button apply" color="primary" (click)="submit()">
              Generate PDF
            </button>
          </div>
        </div>
      </mat-step>

    </mat-horizontal-stepper>
  </form>
</div>